


















































import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
const db = firebase.firestore();
firebase.auth().languageCode = "ja";

@Component
export default class PasswordResetApp extends Vue {
  email = "";
  password = "";
  passwordConfirm = "";
  message = "";
  showPassword = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private ruleEmail: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => /.+@.+\..+/.test(v) || "有効なメールアドレスではありません。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rulePassword: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) =>
      /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i.test(v) ||
      "半角英数8文字以上(英文字と数字共に必須)です。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  setPassword() {
    this.message = "";
    if (this.refs.setPasswordForm.validate()) {
      this.doSetPassword();
    }
  }

  doSetPassword() {
    const auth = firebase.auth();
    const credential = firebase.auth.EmailAuthProvider.credential(
      this.email,
      this.password
    );
    // パスワード変更の場合は変更後一旦セッションを切る
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);

    if (auth.currentUser) {
      auth.currentUser.linkWithCredential(credential).then(
        () => {
          // 正常系
          // メール認証をする
          if (auth !== null && auth.currentUser !== null) {
            // メール認証後のリダイレクト先を設定する
            const domain = window.location.host;
            const protocol = window.location.protocol;
            const redirectURL =
              protocol + "//" + domain + "/password/set-email/done";
            auth.currentUser
              .sendEmailVerification({
                url: redirectURL,
                handleCodeInApp: false,
              })
              .then(() => {
                // プロフィールのメールアドレスを更新する
                if (auth !== null && auth.currentUser !== null) {
                  const uid = auth.currentUser.uid;
                  const userDocRef = db.collection("user").doc(uid);
                  userDocRef.get().then((doc) => {
                    // プロフィールの入力がされていたら更新する
                    if (doc.exists) {
                      const userData = { mail: this.email };
                      userDocRef.set(userData, { merge: true });
                    }
                    // メール認証待ち画面に遷移する
                    this.$router.push({ name: "SignupNotValid" });
                  });
                }
              })
              .catch(() => {
                this.message = "確認メールの送信に失敗しました。";
              });
          }
        },
        () => {
          //エラー系
          this.message = "既にメールアドレスが登録されています。";
        }
      );
    } else {
      this.message = "SNSにログインしていません。";
    }
  }

  public mounted() {
    document.title =
      "新しいパスワードを登録 | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "新しいパスワードを登録 | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }
}
